/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { ComponentChildren } from 'preact';
import { BaseButton } from '../UNSAFE_BaseButton';
import { ButtonLabelLayout } from '../UNSAFE_ButtonLabelLayout';
import { zoomControlStyles } from './themes/TimeComponentStyles.css';
import { useTooltip } from '../hooks/UNSAFE_useTooltip';

type Props = {
  children?: ComponentChildren;
  accessibleLabel: string;
  isDisabled: boolean;
  onAction: () => void;
};

export function TimeComponentZoomControl({
  children,
  accessibleLabel,
  isDisabled = false,
  onAction
}: Props) {
  const {
    tooltipContent,
    tooltipProps: { onFocus, onBlur, ...restTooltipProps }
  } = useTooltip({ text: accessibleLabel });

  // Note that below we ensure the button is not tabbable;
  // one should use a specific set of keyboard shortcuts for zooming instead.
  // TODO: Work with UX to confirm the final look, and then switch to use the EmbeddedIconButton.
  return (
    <div class={zoomControlStyles.base} {...restTooltipProps}>
      <BaseButton
        elementDetails={isDisabled ? undefined : { type: 'span', isFocusable: false }}
        isDisabled={isDisabled}
        size="sm"
        variant="outlined"
        styling={['min']}
        onAction={onAction}>
        <ButtonLabelLayout display={'icons'} startIcon={children} size={'sm'}></ButtonLabelLayout>
      </BaseButton>
      {tooltipContent}
    </div>
  );
}
